import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Table as DefectManagementTable,
    Thead,
    Tbody,
    Tr,
    Th
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import styled from 'styled-components';
import { Modal, Typography } from '@telus-uds/components-web';
import Row from './Row';
import DefectSummary from "./DefectSummary/DefectSummary";
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Table = ({ setFetchData, header = {}, data = [], userProfile, defectId, onDefectSelected }) => {
    const local = useLocaleContext()
    const { DEFECT_MANAGEMENT: { VIEW_DEFECT = '' } = {} } = local === 'en-US' ? EN : FR;

    const [selectedDefect, setSelectedDefect] = useState({});
    const [openModal, setOpenModal] = useState(false);
    let HEADER = []
    if (userProfile.role.name === 'ADMIN') {
        HEADER = ['DEFECT_ID', 'REPORTED_ON', 'DAYS_OPEN', 'WEBFORM', 'REPORTER', 'DEFECT_CATEGORY', 'PRIORITY', 'STATUS', 'ASSIGNEE', 'ACTION'];
    }
    else {
        HEADER = ['DEFECT_ID', 'REPORTED_ON', 'DAYS_OPEN', 'WEBFORM', 'REPORTER', 'DEFECT_CATEGORY', 'PRIORITY', 'STATUS', 'ACTION'];
    }

    useEffect(() => {
        if (defectId) {
            setOpenModal(true)
        }
    }, [defectId])

    return (
        <Fragment>
            <DefectManagementTable>
                <Thead style={{ background: '#e2e2e2' }}>
                    <Tr>
                        {HEADER.map(key => (
                            <Th key={key}><Typography>{header[key]}</Typography></Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody>
                    {data &&
                        data.map((defect, index) => (
                            <Row key={defect.id} index={index} defect={defect} selectedDefect={(selected) => {
                                setSelectedDefect(selected);
                                onDefectSelected(selected)
                            }}
                                openModal={setOpenModal} userProfile={userProfile} />
                        ))}
                </Tbody>
            </DefectManagementTable>
            <Modal
                isOpen={openModal}
                onClose={() => {
                    setOpenModal(false);
                    setFetchData(true);
                    setSelectedDefect({});
                    onDefectSelected({})
                }}
                heading={VIEW_DEFECT}
                variant={{ width: 'xl' }}
            >
                <DefectSummary setFetchData={setFetchData} defectId={defectId} openModal={setOpenModal} defect={selectedDefect} userProfile={userProfile} />
            </Modal>
        </Fragment>
    );
};

Table.propTypes = {
    data: PropTypes.objectOf(PropTypes.array).isRequired,
    header: PropTypes.objectOf(PropTypes.any).isRequired,
    setFetchData: PropTypes.func.isRequired
};

export default Table;
